<app-slideshow>
</app-slideshow>

<app-whatsappicon></app-whatsappicon>
<app-install-app 
    *ngIf="deferredPrompt != null"  
    (closeEvent)="closeCard()"
    (installEvent)="installPWA()"
>
</app-install-app>
<app-ultimas-propiedades></app-ultimas-propiedades>
<app-servicios></app-servicios>
<app-mapa></app-mapa>
<app-asesores></app-asesores>
<app-aliados></app-aliados>

<!--<app-footer></app-footer>-->